
import { useDispatch, useSelector } from "react-redux"
import ImageUpload from "screens/components/basic/ImageUpload"
import DeleteIcon from '@mui/icons-material/Delete';
import * as types from 'constants/actionTypes';

const UploadLogo=({ logo, setLogo })=>{
    const img = useSelector(state => state.form.SEOSettingsLogoImageURL)
    const dispatch = useDispatch()

    return (
        <div className="upload-icon-container" >
      <div className="prv" >
        {(img || logo) && <div>
          {(img || logo) && <span className="remove-spn" onClick={() => { dispatch({ type: types.FORM_INPUT, value: null, name: "SEOSettingsLogoImageURL" }); setLogo() }}><DeleteIcon /></span>}
          <img src={img ? img : logo ? logo : ""} />
        </div>
        }
      </div>
      <div>
        <ImageUpload name={`SEOSettingsLogoImageURL`} text={"Upload Logo"} accept="image/png, image/jpeg," displayPreview={false} />
      </div>
    
    </div>
    )
}

export default UploadLogo
